import type { ChurchEvent } from "../../model/launchpad";
import { sortedByStartDate } from "../../util/date";
import EventCard from "./EventCard";
import UpcomingEventsSection from "./UpcomingEventsSection";

// Web port of EventsHomeSectionView
// (EventsFeature/View/Component/EventsHomeSectionView.swift).
//
// The soonest event as a hero card, with the next few listed below it. The app
// puts the two side by side when there is room (ViewThatFits, 320pt columns);
// the web layout's content column is narrower than two of those, so they
// always stack.

export interface EventsHomeSectionProps {
  events: ChurchEvent[];
  onEventClick?: (event: ChurchEvent) => void;
}

export default function EventsHomeSection(props: EventsHomeSectionProps) {
  // Nothing guarantees the API returns these in order, so sort rather than
  // trusting the payload — same as the app.
  const events = sortedByStartDate(props.events);
  const featured = events[0];
  const upcoming = events.slice(1, 4);

  if (!featured) return null;

  return <div className="flex flex-col gap-4">
    {/* The card sections in the feed carry their own horizontal padding. */}
    <div className="px-4">
      <EventCard
        event={featured}
        onClick={props.onEventClick && (() => props.onEventClick?.(featured))}
      />
    </div>

    <UpcomingEventsSection events={upcoming} onEventClick={props.onEventClick} />
  </div>
}
